import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import {
  MuiColorInput,
  MuiColorInputColors,
  MuiColorInputFormat,
} from 'mui-color-input';
import { useState } from 'react';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import { useNotify } from 'src/context/ContextNotify';

type RowsProps = {
  item: any;
};

const Rows: React.FC<RowsProps> = (props) => {
  const notifyContext = useNotify();
  const [dataRow, setDataRow] = useState(props.item);
  const [edit, setEdit] = useState(false);

  const handleColorChange = (newValue: string, colors: MuiColorInputColors) => {
    setDataRow((prevState: any) => ({
      ...prevState,
      activecolor: newValue,
    }));
  };

  const handleClose = () => {
    setEdit(false);
    setDataRow(props.item);
  };

  const format: MuiColorInputFormat = 'hex';

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setDataRow((prevState: any) => ({
      ...prevState,
      note: event.target.value,
    }));
  };

  const handleStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDataRow((prevState: any) => ({
      ...prevState,
      status: event.target.checked ? '1' : '0',
    }));
  };

  const handleSave = () => {
    try {
      const token = getToken();
      postAPI(`/master/patienticon-save?token=${token}`, {
        activecolor: dataRow.activecolor,
        codename: dataRow.codename,
        edit: false,
        namej: dataRow.namej,
        note: dataRow.note,
        piconid: dataRow.piconid,
        status: dataRow.status === '1' ? true : false,
      }).then((res) => {
        if (res && res.code === 200) {
          notifyContext.setNotifyMessage({
            show: true,
            message: '保存出来ました。',
            type: 'success',
          });
          setEdit(false);
        }
        if (res.code === 500 || res.code === 501) {
          notifyContext.setNotifyMessage({
            show: true,
            message: res.msg || 'Failed to post data',
            type: 'error'
          });
        }
      });
    } catch (error) {
      console.error('Failed to post data:', error);
      return;
    }
  };

  return (
    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell sx={{ color: dataRow.activecolor }}>
        <span
          className={`q-icon ${
            dataRow.codename !== '' ? 'notranslate material-icons' : ''
          } cursor-pointer q-mr-sm`}
          aria-hidden='true'
          role='presentation'
          style={{ color: dataRow.activecolor }}
        >
          {dataRow.namej}
        </span>
      </TableCell>
      <TableCell>
        {!edit ? (
          dataRow.activecolor
        ) : (
          <MuiColorInput
            format={format}
            value={dataRow.activecolor || ''}
            onChange={handleColorChange}
            isAlphaHidden
            size="small"
          />
        )}
      </TableCell>
      <TableCell>
        {!edit ? (
          dataRow.status === '1' ? (
            '有効'
          ) : (
            '無効'
          )
        ) : (
          <FormControlLabel
            control={
              <Checkbox
                checked={dataRow.status === '1'}
                onChange={(event) => handleStatusChange(event)}
              />
            }
            label='有効'
            sx={{
              '& .MuiSvgIcon-root': { fontSize: '20px' },
              '& .MuiTypography-root': {
                fontSize: '14px',
                wordBreak: 'break-word',
              },
            }}
          />
        )}
      </TableCell>
      <TableCell>
        {!edit ? (
          dataRow.note
        ) : (
          <TextField
            autoFocus
            margin='dense'
            id='note'
            variant='standard'
            value={dataRow.note || ''}
            onChange={(event) => handleInputChange(event)}
            sx={{ width: '100%', minWidth: '200px' }}
          />
        )}
      </TableCell>
      <TableCell sx={{ width: '150px' }} align='center'>
        {!edit ? (
          <Box
            component={'img'}
            src='/images/icons/ic-edit.svg'
            alt='edit'
            sx={{ cursor: 'pointer' }}
            onClick={() => setEdit(true)}
          />
        ) : (
          <>
            <Box
              component={'img'}
              src='/images/icons/ic-close.svg'
              alt='edit'
              sx={{ cursor: 'pointer' }}
              onClick={handleClose}
            />
            <SaveIcon
              sx={{ color: '#a3aed0', cursor: 'pointer', ml: '10px' }}
              onClick={handleSave}
            />
          </>
        )}
      </TableCell>
    </TableRow>
  );
};

export default Rows;
